<template>
    <v-dialog v-model="showDynamicFormDialog" content-class="overlay" width="80%" height="800px">
        <v-card>
            <v-card-title>
                {{ $t("res_DialogTitle_AddDynamicForm") }}
            </v-card-title>
            <br><br>
            <div class="card-body">
                <intalio-form-builder settings=''>
                </intalio-form-builder>
            </div>
            <v-card-actions class="gap-2 sticky-actions">
                <v-spacer></v-spacer>
                <v-btn class="light-blue" id="closeButton" @click="closeDynamicFormDialog()">{{
                    $t("res_ButtonText_Cancel") }}</v-btn>
                <v-btn class="primary" style="min-width: 100px !important;" @click="saveDynamicForm">Save</v-btn>
            </v-card-actions>
        </v-card>
    </v-dialog>
</template>

<script>
import axios from 'axios'
import constants from '@/assets/js/constants'
import * as utils from '@/assets/js/common.js'
import _ from '@/assets/js/dynamic-froms';
import { json } from 'd3';
export default {
    name: 'DynamicFomrBuilder',
    components: {},
    data() {
        return {
            showAddNewDynamicFormDialog: true,
            showDynamicFormDialog: false,
        }
    },
    props: {
        structure_id: null,
        template_id: null,
        category_id: null
    },
    mounted() {

        this.openDynamicFormDialog();
        this.setAttribute();
        //fix css modal over modal issue this hack should be fixed in another way 
        setInterval(() => {
            var dynamicFormRenderedPopup = document.getElementsByClassName("formio-dialog-content")[0];
            if (dynamicFormRenderedPopup)
                dynamicFormRenderedPopup.classList.add("v-dialog__content--active");

        }, 100);
    },
    methods:
    {
        setAttribute() {

            var form = document.querySelector("intalio-form-builder");
            var structureNumber = !utils.CheckIfNullOrEmpty(this.structure_id) ? "\"" + this.structure_id + "\"" : "\"" + 0 + "\"";
            var templateId = !utils.CheckIfNullOrEmpty(this.template_id) ? "\"" + this.template_id + "\"" : "\"" + 0 + "\"";
            var categoryId = !utils.CheckIfNullOrEmpty(this.category_id) ? "\"" + this.category_id + "\"" : "\"" + 0 + "\"";

            var baseUrl = '"' + constants.baseApiUrl + '"';
            var attr = `{
                        "level": "advance",
                        "backendSetting": {
                            "url": ${baseUrl},
                            "header": "{}"
                        },
                        "builderFilter": {
                            "id": "0",
                            "templateName": "",
                            "templateId": ${templateId},
                            "referenceNumber": "",
                            "structureId":${structureNumber},
                            "categoryId": ${categoryId}
                        }
                        
                    }`;

            if (form)
                form.setAttribute("settings", attr);
            else {
                setTimeout(() => {

                    this.setAttribute();
                }, 100);
            }
        },
        translate(text) {
            if (this.$i18n.locale == 'en')
                return this.$i18n._getMessages().en[text] == null ? text : this.$i18n._getMessages().en[text]
            else
                return this.$i18n._getMessages().ar[text] == null ? text : this.$i18n._getMessages().ar[text]
        },
        openDynamicFormDialog() {
            this.showDynamicFormDialog = true;
        },
        closeDynamicFormDialog() {
            this.showDynamicFormDialog = false;
            this.$emit('close-Dialog');
        },
        saveDynamicForm() {
            var submitButton = document.getElementById("dynamicFormSubmitButton");
            submitButton.click.apply(submitButton);
            window.showAlert(this.translate('res_Msgs_DynamicFormSaved'), 'success');
            this.closeDynamicFormDialog();
        }
    },

}
</script>

<style>
.dynamicFormsStyle {
    z-index: 999 !important;
    position: absolute;
    margin-top: 9.1%;
    float: right;
    left: 85%
}

.v-dialog {
    /* height: inherit !important; */
}

.formio-dialog {}

.buttonHandler {}
</style>